import { Icon } from "../../Icon";
import { IIcon } from "../../interfaces/IIcon";

export const activityLogIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" rx="3"/><path fill="#FFF" fill-rule="nonzero" d="M27.635 41l1.242-4.078h6.246L36.365 41h3.914l-6.07-17.203h-4.441L23.72 41h3.914zm6.62-7.125h-4.464c1.219-3.945 1.957-6.418 2.215-7.418.062.281.166.664.31 1.148.145.485.791 2.575 1.94 6.27z"/></svg>`
);
